import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { size } from 'lodash';

import { api } from '../../../api';
import { getOperatorsStatus } from '../searchStatus/selectors';
import { sortFunction } from '../utils';

class OperatorsStatuses extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { operators: {} };
  }

  async componentDidMount() {
    const response = await api.getReferencesOperators();
    const operators = {};
    response.operators.forEach((operator) => {
      const {
        id,
        name,
        logo: {
          x1: { url: logo },
        },
      } = operator;
      operators[id] = { name, logo };
    });
    this.setState({ operators });
  }

  render() {
    const { status } = this.props;
    const { operators } = this.state;

    if (!size(status)) {
      return 'loading...';
    }

    return (
      <div className="operators-status">
        <h4 className="operators-status__title">Статусы туроператоров</h4>
        <ul className="operators-status__list">
          {status.sort(sortFunction).map((operatorStatus, operatorId) => {
            const { name = operatorId, logo } = operators[operatorId] || {};
            return (
              <li className="operators-status__item" key={name}>
                <span className="operators-status__logo">
                  <img src={logo} alt={name} title={name} />
                </span>
                <span className={`operators-status__status--${operatorStatus}`}>
                  {operatorStatus}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

OperatorsStatuses.propTypes = {
  status: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  status: getOperatorsStatus(state),
});

export default connect(mapStateToProps)(OperatorsStatuses);
